import {PageLayout, Filters, EnvironmentsAdvancedTable} from '~/components'
import {EnvironmentsPageHeader} from './page_header'
import {Environment, BillingActivity} from '@eitje/api'

export const Environments = () => {
	const environments = Environment.useAll({joins: ['organisations']})
	const billingActivities = BillingActivity.useAll() //TODO: use joins once this becomes available from BE

	const items = environments.map(environment => {
		const {active_user_ids} = billingActivities.find(billingActivity => billingActivity.environment_id === environment.id) || {}
		return {...environment, activeUsers: active_user_ids?.length || 0}
	})

	return (
		<PageLayout
			name="environments"
			headers={[<EnvironmentsPageHeader key={0} />, <Filters key={1} />]}
			filterProps={{items, filters: ['organisation', 'environment', 'firmStatus']}}
		>
			<EnvironmentsAdvancedTable />
		</PageLayout>
	)
}
